module.exports = __webpack_public_path__ + "static/media/star12.c87d83d0.svg";